import * as React from 'react';
import {useState} from 'react';
import {SortOrder} from '../../../shared/CommonInterfaces';
import {SortByColumns} from '../ShipmentInterfaces';

import DropDown, {DropDownColor, DropDownOption, DropDownType} from '../../../shared/DropDown';

interface SortDirectionProps {
  onChange: (sortByColumn: SortByColumns, direction: SortOrder) => void;
  initialColumn?: SortByColumns;
  initialDirection?: SortOrder;
}

function optionFromColumnAndDirection(column: SortByColumns, direction: SortOrder): string {
  switch (column) {
    case SortByColumns.CreatedAt:
      return direction === SortOrder.DESC ? 'createdAtDesc' : 'createdAtAsc';
    case SortByColumns.ShipBy:
      return direction === SortOrder.ASC ? 'shipByAsc' : 'shipByAsc'; // Assuming no DESC for ShipBy
    default:
      return 'shipByAsc'; // Default fallback
  }
}

const SortDirection: React.FC<SortDirectionProps> = (props) => {
  const options = [
    {name: 'Ship By', value: 'shipByAsc'},
    {name: 'Newest', value: 'createdAtDesc'},
    {name: 'Oldest', value: 'createdAtAsc'}
  ];
  const initialOption =
    options.find(
      (option) =>
        option.value ===
        optionFromColumnAndDirection(
          props.initialColumn || SortByColumns.ShipBy,
          props.initialDirection || SortOrder.ASC
        )
    ) || options[0];

  const [selectedOption, setSelectedOption] = useState<DropDownOption>(initialOption);

  const onSelect = (option: DropDownOption) => {
    switch (option.value) {
      case 'createdAtDesc':
        setSelectedOption(option);
        props.onChange(SortByColumns.CreatedAt, SortOrder.DESC);
        break;
      case 'createdAtAsc':
        setSelectedOption(option);
        props.onChange(SortByColumns.CreatedAt, SortOrder.ASC);
        break;
      case 'shipByAsc':
        setSelectedOption(option);
        props.onChange(SortByColumns.ShipBy, SortOrder.ASC);
        break;
      default:
        setSelectedOption(option);
        break;
    }
  };

  return (
    <DropDown
      options={options}
      selected={selectedOption}
      color={DropDownColor.white}
      type={DropDownType.secondary}
      prefixText="Sort By:  "
      onSelect={onSelect}
    />
  );
};

export default SortDirection;
